import { Component, EventEmitter, model, Output, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { TranslatePipe } from '../../directives/TranslatePipe';

@Component({
  selector: 'app-search-bar',
  standalone: true,
  imports: [CommonModule, FormsModule, TranslatePipe],
  templateUrl: './search-bar.component.html'
})
export class SearchBarComponent {
  searchTerm = model.required<string>();

  @Output() search = new EventEmitter<string>();

  @Input() searchState: 'idle' | 'typing' | 'searching' = 'idle';

  onSearchTermChange(newSearchTerm: string) {
    // La croix native d'un input[type=search] peut emettre l'evenement DOM au lieu
    // d'une chaine : on ne laisse passer qu'une string, sinon .trim() explose en aval.
    const term = typeof newSearchTerm === 'string' ? newSearchTerm : '';
    this.searchTerm.set(term);
    this.search.emit(term);
  }

  // Entree et la croix d'un input[type=search] emettent un evenement DOM "search" :
  // s'il remontait jusqu'au (search) du parent, il y arriverait comme Event (et non
  // comme string) et viderait le terme. On l'arrete ici et on reemet la valeur du
  // champ, relue en differe : la croix peut la vider apres l'evenement.
  onNativeSearch(input: HTMLInputElement, event: Event) {
    event.stopPropagation();
    setTimeout(() => this.onSearchTermChange(input.value));
  }
}
